<template>
  <div class="sn-wrap">
    <nav class="sn-content" aria-label="Section navigation">
      <ul class="sn-list">
        <template v-for="(item, index) in items">
          <li class="sn-item" :key="index">
            <router-link class="sn-link" exact-active-class="sn-link--active" :to="item.to">
              {{ item.title }}
            </router-link>
          </li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'NavList',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.sn-wrap {
  background: #fff;
  border-bottom: 1px solid #f0f0f5;
}

.sn-content {
  width: 100%;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 12px 60px;
}

.sn-list {
  display: flex;
  align-items: center;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.sn-item {
  display: inline-flex;
}

.sn-link {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #5a5a6f;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  padding: 0 13px;
  text-decoration: none;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.sn-link:hover {
  background: #f7f7fb;
  border-color: #e8e8ed;
  color: #4338ca;
}

.sn-link--active {
  background: #f0effe;
  border-color: #d8d4ff;
  color: #413b94;
}

@media (max-width: 900px) {
  .sn-content {
    overflow-x: auto;
    padding-left: 24px;
    padding-right: 24px;
  }

  .sn-list {
    width: max-content;
  }
}
</style>



// WEBPACK FOOTER //
// SubNavigation.vue?5a83673d